import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import LogoText from "../assets/dcg_logo_name.png";
import {Link} from "react-router-dom";

const muiTheme = createTheme({
    palette: {
        custom: {
            main: '#FFF'
        },
    },
    components: {
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: "#000",
                }
            }
        }
    }
});

const useStyles = theme => ({
    panel: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
    },
    content: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        flexDirection: 'column',
        padding: '70px 0 0 0',
    },
    menus: {
        position: 'absolute',
        top: '10px',
        width: '100%',
    },
    menusSmall: {
        display: 'block',
        position: 'absolute',
        right: '10px',

        [theme.breakpoints.up('md')]: {
            display: 'none',
        }
    },
    menusBig: {
        display: 'none',
        fontFamily: 'Montserrat',
        fontSize: '1.2em',
        fontWeight: 'bold',
        letterSpacing: '0.2em',
        textTransform: 'uppercase',
        color: '#FFF',
        padding: '20px 0 0 0',

        '& a': {
            padding: '0 15px',
            color: '#FFF',
            textDecoration: 'none',
        },

        '& a:hover': {
            color: '#FFF',
            textDecoration: 'none',
            textShadow: '-1px 3px #FF3600',
        },

        '& $menuActive': {
            color: '#FFF',
            textDecoration: 'none',
            textShadow: '-1px 3px #FF3600',
        },

        [theme.breakpoints.up('md')]: {
            display: 'block',
        }
    },
    menuActive: {
    },
    menusBigLeft: {
        position: 'absolute',
        left: '10px',
    },
    menusBigRight: {
        position: 'absolute',
        right: '10px',
    },
    drawerPanel: {
        padding: '20px 28px 50px 28px',
    },
    drawerTitle: {
        margin: '0 0 40px 0',
    },
    drawerMenu: {
        fontFamily: 'Montserrat',
        fontSize: '1.2em',
        fontWeight: 'bold',
        letterSpacing: '0.2em',
        textTransform: 'uppercase',
        color: '#FFF',
        padding: '15px 0',

        '& a': {
            padding: '0',
            color: '#FFF',
            textDecoration: 'none',
        },

        '& a:hover': {
            color: '#FFF',
            textDecoration: 'none',
            textShadow: '-1px 3px #FF3600',
        },

        '& $menuActive': {
            color: '#FFF',
            textDecoration: 'none',
            textShadow: '-1px 3px #FF3600',
        },
    }
});

class MenuPanel extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        }
    }

    render() {
        const { classes } = this.props;
        let self = this;

        function RenderMenu(props) {
            if (props.page === props.currPage) {
                return (
                    <Link className={classes.menuActive} to={props.to}>{props.title}</Link>
                )
            }

            return (
                <Link to={props.to}>{props.title}</Link>
            )
        }

        const toggleDrawer = (newOpen: boolean) => () => {
            self.setState({ open: newOpen });
        };

        const DrawerList = (
            <Box role="presentation" onClick={toggleDrawer(false)}>
                <div className={classes.drawerPanel}>
                    <div className={classes.drawerTitle}><img src={LogoText} alt={"Dragon Community Gym Text Logo"}/></div>
                    <div className={classes.drawerMenu}><RenderMenu to={"/"} title={"Welcome"} page={"welcome"} currPage={self.props.page} /></div>
                    <div className={classes.drawerMenu}><RenderMenu to={"/about"} title={"About"} page={"about"} currPage={self.props.page} /></div>
                    <div className={classes.drawerMenu}><a target="_blank" rel="noopener noreferrer" href="https://open.spotify.com/episode/2ANUhgn2BhIHH6ezkix2Vd?si=b5a51efb1aa748f4">Podcast</a></div>
                    <div className={classes.drawerMenu}><a target="_blank" rel="noopener noreferrer" href="mailto:matt@dragoncommunitygym.com">Contact</a></div>
                </div>
            </Box>
        );

        return (
            <ThemeProvider theme={muiTheme}>

                <div className={classes.panel}>
                    <div className={classes.content}>

                        <div className={classes.menus}>
                            <div className={classes.menusSmall}>
                                <IconButton
                                    color="custom"
                                    aria-label="open drawer"
                                    onClick={toggleDrawer(true)}
                                >
                                    <MenuIcon fontSize="large" />
                                </IconButton>
                            </div>

                            <div className={classes.menusBig}>
                                <div className={classes.menusBigLeft}>
                                <RenderMenu to={"/"} title={"Welcome"} page={"welcome"} currPage={this.props.page} />
                                <RenderMenu to={"/about"} title={"About"} page={"about"} currPage={this.props.page} />
                                </div>
                                <div className={classes.menusBigRight}><a target="_blank" rel="noopener noreferrer" href="https://open.spotify.com/episode/2ANUhgn2BhIHH6ezkix2Vd?si=b5a51efb1aa748f4">Podcast</a><a target="_blank" rel="noopener noreferrer" href="mailto:matt@dragoncommunitygym.com">Contact</a></div>
                            </div>
                        </div>

                        <Drawer anchor={'top'} open={self.state.open} onClose={toggleDrawer(false)}>
                            {DrawerList}
                        </Drawer>

                    </div>
                </div>

            </ThemeProvider>
        )
    }
}

export default withStyles(useStyles)(MenuPanel)